<template>
<modal title="Mark as false positive">
  <p>Mark this vulnerablity as being a false postive.</p>
  <div>
    <select-input
      :error="$root.errorBag.type_id"
      :items="types"
      v-model="falsePositive.type_id"
      value-key="id"
      label-key="description"
      required>
      Reason
    </select-input>
    <text-area
      :error="$root.errorBag.reason"
      v-model="falsePositive.reason"
      :required="falsePositive.type_id === 1">
      Explanation
    </text-area>
  </div>
  <template #footer>
    <div class="is-flex align-end">
      <action-button @click="$close(false)" class="is-small mr">Cancel</action-button>
      <submit-button @submit="saveFalsePositive">
        Save
      </submit-button>
    </div>
  </template>
</modal>  
</template>
<script>
import { loadFalsePositiveTypes, saveFalsePositive } from '@/api/finding'
export default {

  props: {
    finding: {
      type: Object,
      default: () => ({})
    }
  },

  data: () => ({
    saving: false,
    falsePositive: {
      type_id: '',
      reason: ''
    },
    types: []
  }),

  created() {
    loadFalsePositiveTypes(this.finding.id, ({data}) => {
      this.types = data
    }, error => {})
  },

  methods: {
    saveFalsePositive() {
      this.saving = true
      saveFalsePositive({
        ...this.falsePositive,
        findingId: this.finding.id
      }, ({data}) => {
        this.$toast.success('Saved')
        this.saving = false
        this.$close(data)
      }, error => this.saving = false)
    }
  }
}
</script>